import * as React from 'react'
import styled from 'styled-components'

import media from '../../../../services/generateMediaQueries'
import formatDisplaySchedule from '../../../../services/schedule/formatDisplaySchedule'

import Section from '../../../../components/ui/Section/Section'
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import PromoCard from '../../../../components/home/PromoCard/PromoCard'

const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;

  & > section {
    margin-bottom: 0;
  }

  ${media.lessThan('medium')`
    background: var(--color-secondary);
  `}
`

class PromosSection extends React.Component {
  promosSlider = React.createRef()

  promosSliderNext = () => {
    this.promosSlider.current.slickNext()
  }

  promosSliderPrev = () => {
    this.promosSlider.current.slickPrev()
  }

  render() {
    const { promoPreview = {} } = this.props

    const formattedSchedule = formatDisplaySchedule(promoPreview.schedule || '')

    return (
      <SectionWrapper>
        <Section
          sectionTitle="section.title"
          sectionText="section.description"
          sliderNext={this.promosSliderNext}
          sliderPrev={this.promosSliderPrev}
          onClick={e => e.preventDefault()}
          contentDirection="rtl"
          reverse
          tertiary
        >
          <CardSlider
            ref={this.promosSlider}
            dataSource={Array.from(Array(3))}
            initialSlide={2}
            renderItem={(item, index) => (
              <PromoCard
                key={index}
                id={2 - (index + 1)}
                bannerImageUrl={promoPreview.imageUrl || ''}
                logoImageUrl={promoPreview.logoUrl || ''}
                subtitle={formattedSchedule || ''}
                title={promoPreview.title || ''}
                onClick={e => e.preventDefault()}
              />
            )}
          />
        </Section>
      </SectionWrapper>
    )
  }
}

PromosSection.defaultProps = {
  // TODO: specify default props
}

PromosSection.propTypes = {
  // TODO: specify prop types
}

export default PromosSection
